export default __webpack_public_path__ + "static/media/contributeItsSimple.623dfe09.png";